var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningOctagon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M19.313 26.985h-6.626c-1.387 0-2.054-.448-2.764-1.223L5.905 21.31C5.185 20.513 5 19.99 5 18.909V13.07c0-1.09.185-1.604.905-2.4l4.018-4.453c.71-.775 1.377-1.233 2.764-1.233h6.626c1.387 0 2.044.458 2.764 1.233l4.018 4.452c.72.797.905 1.31.905 2.401v5.838c0 1.08-.185 1.604-.905 2.4l-4.018 4.453c-.72.775-1.377 1.223-2.764 1.223zm-4.28-9.964c.011.633.346.979.967.979.598 0 .944-.334.956-.98l.173-6.3c.012-.633-.478-1.098-1.135-1.098-.67 0-1.135.453-1.123 1.087zm-.365 3.899c0 .704.62 1.277 1.338 1.277s1.338-.56 1.338-1.278-.609-1.29-1.338-1.29c-.729 0-1.338.586-1.338 1.29z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningOctagon);
export default __webpack_public_path__ + "static/media/Warning_Octagon.a0f9d77169bd0f0ebb9789d8759b39c7.svg";
export { ForwardRef as ReactComponent };